module.exports = __webpack_public_path__ + "static/img/lunwenrense.e73ce3b1.jpeg";